/**
 * OriginBadge Component - Secondary origin badge for leads
 * Reusable across cards, table, and side panel
 */

import React from "react";
import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledChip = styled(Chip)({
  fontWeight: 500,
  fontSize: "0.7rem",
  height: "22px",
  "&.origin-pwa": {
    backgroundColor: "rgba(156, 39, 176, 0.1)",
    color: "rgba(156, 39, 176, 0.9)",
    borderColor: "rgba(156, 39, 176, 0.3)",
  },
  "&.origin-manual": {
    backgroundColor: "rgba(25, 118, 210, 0.1)",
    color: "rgba(25, 118, 210, 0.9)",
    borderColor: "rgba(25, 118, 210, 0.3)",
  },
  "&.origin-whatsapp": {
    backgroundColor: "rgba(46, 125, 50, 0.1)",
    color: "rgba(46, 125, 50, 0.9)",
    borderColor: "rgba(46, 125, 50, 0.3)",
  },
  "&.origin-default": {
    backgroundColor: "rgba(158, 158, 158, 0.1)",
    color: "rgba(158, 158, 158, 0.9)",
    borderColor: "rgba(158, 158, 158, 0.3)",
  },
});

const getOriginLabel = (lead) => {
  const sourceType = lead?.source?.type || lead?.source || "whatsapp";
  switch (sourceType) {
    case "manual":
      return "Manual";
    case "pwa":
      return "PWA";
    case "whatsapp":
      return "WhatsApp";
    default:
      return sourceType.charAt(0).toUpperCase() + sourceType.slice(1);
  }
};

const getOriginClass = (lead) => {
  const sourceType = lead?.source?.type || lead?.source || "whatsapp";
  switch (sourceType) {
    case "manual":
      return "origin-manual";
    case "pwa":
      return "origin-pwa";
    case "whatsapp":
      return "origin-whatsapp";
    default:
      return "origin-default";
  }
};

/**
 * OriginBadge Component
 * @param {Object} props
 * @param {Object} props.lead - Lead object
 * @param {string} [props.size="small"] - Chip size
 * @param {string} [props.variant="outlined"] - Chip variant
 */
const OriginBadge = ({ lead, size = "small", variant = "outlined" }) => {
  if (!lead) return null;

  return (
    <StyledChip
      label={getOriginLabel(lead)}
      size={size}
      variant={variant}
      className={getOriginClass(lead)}
    />
  );
};

export default OriginBadge;

